import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'eva-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LandingComponent { }

